import { styled as styledMui } from '@mui/system';

export { css, keyframes, alpha } from '@mui/system';

export const styled = (component, options = {}) => {
  const mergedOptions = {
    shouldForwardProp: (prop) => !prop.startsWith('$'),
    ...options,
  };
  return styledMui(component, mergedOptions);
};
